import React from 'react';

import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

import useThemeModePreference, { THEME_MODES, isThemeMode } from '~/hooks/useThemeModePreference';

export default function ThemeModeMenuItem() {
  const { themeMode, setThemeMode } = useThemeModePreference();

  return (
    <Box
      component="li"
      tabIndex={-1}
      onFocus={(event) => {
        if (event.target === event.currentTarget) {
          event.currentTarget.querySelector<HTMLButtonElement>('button[aria-pressed="true"]')?.focus();
        }
      }}
      onKeyDown={(event) => {
        // Let users tab through the choices without MenuList closing the menu.
        if (event.key === 'Tab') {
          event.stopPropagation();
        }
      }}
      sx={{ px: 2, py: 1 }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Appearance
      </Typography>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        color="primary"
        value={themeMode}
        aria-label="Appearance"
        onChange={(_, value: unknown) => {
          if (isThemeMode(value)) {
            setThemeMode(value);
          }
        }}
      >
        <ToggleButton value={THEME_MODES.SYSTEM}>System</ToggleButton>
        <ToggleButton value={THEME_MODES.LIGHT}>Light</ToggleButton>
        <ToggleButton value={THEME_MODES.DARK}>Dark</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
